module.exports = __webpack_public_path__ + "static/media/landingCollaborator8.e0d91260.jpg";